<template>
<div>

  <h1>{{ msg }}</h1>
  <HelloWorld msg="msg"/>

  <br>

  <section>
    <b-button @click="clickMe" type="is-success">Click Me</b-button>
  </section>

  <section>

    <h2>{{pickeddate}}</h2>
    <b-field>

    </b-field>
    <b-datepicker v-model="pickeddate" inline
                  :unselectable-days-of-week="[0, 6]">
<!--                  date-formatter=" (date) => date.toLocaleDateString('de', { year: 'numeric', month: 'short', day: 'numeric' }) "-->

    </b-datepicker>
  </section>


</div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';

export default {

  name: 'Demo',
  components: [
    HelloWorld
  ],
  data() {
    return  {
      pickeddate: new Date()
    }
  },
  props: {
    msg: String,
    // pickeddate: String
  },
  methods: {
    clickMe () {
      window.alert(this.msg)
    }
  }

}

</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
